import { IGoal } from "@interfaces/user/refs";
import { createContext, useContext } from "react";

export const GoalContext = createContext<IGoal>(undefined as any);
export const GoalProvider = GoalContext.Provider;

export function useGoalContext(): IGoal | undefined {
    return useContext(GoalContext);
}